import React from 'react';
import { useStore } from '../../stores';
import classNames from 'classnames'

import { Layers } from '../../stores/layers';

import { joinText } from '../../helpers/textUtils';
import { higestRankedCategory } from '../../helpers/poiHelper';
import { useTranslateFunction } from '../../helpers/useTranslationHook';

export const Header = ({ className }) => {

  const { config, poi } = useStore();

  const categoryTranslation = useTranslateFunction(Layers.filter).t;

  const cityAndCountryString = joinText(
    [poi.active?.address?.city, poi.active?.address?.country],
    ', ',
  );

  return (

    <div className={classNames('flex items-start relative', className )}>

      <div>
                
        <div className="pl-6 relative text-neutral-400 text-sm">
          <span className={`text-[16px] absolute top-[1px] left-0 gys gys-${higestRankedCategory(poi.active).name}`} />
          {categoryTranslation(higestRankedCategory(poi.active).name)}
        </div>

        <div className="my-1 text-2xl font-bold text-neutral-900">
          {/* TODO add fallback */}
          {poi.active[config.gysService.language]?.title || ''}
        </div>

        <div className="text-md text-neutral-600">
          {cityAndCountryString ? cityAndCountryString : ''}
        </div>

      </div>
      
    </div>
    
  );
  
};
